import get from "lodash/get";
import type { Action } from "../../actions/types";

export type StoreState = {
  balance?: string;
  currency?: string;
  customerId?: string;
  merchantId?: string;
};

export const initialState = {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "LOYALTY_GET_LEDGER_SUCCESS") {
    return action.response.data;
  }

  if (action.type === "ACCOUNT_CREDIT_REDEEM_SUCCESS") {
    const balance = get(action, "response.data.transaction.ledger.total");

    return { ...state, balance: String(balance) };
  }

  if (action.type === "ACCOUNT_CREDIT_REVERSE_SUCCESS") {
    const reversedAmount = get(
      action,
      "response.data.reversed.derivative.ledgerAmount"
    );
    const balance = Number(state.balance) + Number(reversedAmount);

    return { ...state, balance: String(balance) };
  }

  return state;
}
